import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "top-scoring-list" }
const _hoisted_2 = {
  key: 1,
  class: "top-scoring-list-body"
}

import { PropType } from 'vue'

import NotificationBanner from '@/components/common/NotificationBanner.vue'
import { TopScoringList } from '@/store/modules/top-scoring-lists.types'
import { formatFloat, formatGender } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'TopScoringList',
  props: {
  list: {
    type: Object as PropType<TopScoringList | undefined>,
    default: null,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.list?.bowlers.length === 0)
      ? (_openBlock(), _createBlock(NotificationBanner, {
          key: 0,
          message: _ctx.$t('top-scoring-lists.empty-list')
        }, null, 8, ["message"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("small", null, null, -1)),
          _createElementVNode("small", null, _toDisplayString(_ctx.$t('top-scoring-lists.heading-name')), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.$t('top-scoring-lists.heading-club')), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.$t('top-scoring-lists.heading-klass')), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.$t('top-scoring-lists.heading-age-group')), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.$t('top-scoring-lists.heading-gender')), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.$t('top-scoring-lists.heading-current-average')), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.$t('top-scoring-lists.heading-season-games')), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.$t('top-scoring-lists.heading-cut-score-games')), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.$t('top-scoring-lists.heading-previous-average')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list?.bowlers, (entry, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createElementVNode("small", null, _toDisplayString(1 + index), 1),
              _createElementVNode("small", null, _toDisplayString(entry.bowler.lastName) + ", " + _toDisplayString(entry.bowler.firstName), 1),
              _createElementVNode("small", null, _toDisplayString(entry.bowler.activeClub), 1),
              _createElementVNode("small", null, _toDisplayString(entry.bowler.klass), 1),
              _createElementVNode("small", null, _toDisplayString(entry.bowler.ageGroupName), 1),
              _createElementVNode("small", null, _toDisplayString(_unref(formatGender)(entry.bowler.gender)), 1),
              _createElementVNode("small", null, _toDisplayString(_unref(formatFloat)(entry.averages.current, 2)), 1),
              _createElementVNode("small", null, _toDisplayString(_unref(formatFloat)(entry.gameCounts.currentSeason, 0)), 1),
              _createElementVNode("small", null, _toDisplayString(_unref(formatFloat)(entry.gameCounts.cutScore, 0)), 1),
              _createElementVNode("small", null, _toDisplayString(_unref(formatFloat)(entry.averages.previous, 2)), 1)
            ], 64))
          }), 128))
        ]))
  ]))
}
}

})